import { useQuery } from 'react-query';
import { useEffect, useState } from 'react';

import { getOffers } from '../../lib/apiService';
import { offerTypeLabels, faqList } from '../../lib/labels';
import { getAllOffers, getDigitalOffers } from './appSubscribeGetData';
import Header from '../Header';
import Footer from '../Footer';
import OfferTypeConfirm from '../OfferTypeConfirm';
import Faq from '../Faq';
import { StyledAllProducts, StyledWrapper, StyledMain } from './AppSubscribe.styles';

function AppSubscribe({ message1, message2, brief, goToURLParams }) {
  const offersQuery = useQuery('offers', getOffers);

  const [offers, setOffers] = useState([]);

  useEffect(async () => {
    if (!offersQuery.isLoading) {
      const filteredOffers = brief
        ? await getDigitalOffers(offersQuery.data, goToURLParams, brief)
        : await getAllOffers(offersQuery.data, goToURLParams, brief);
      setOffers(filteredOffers);
    }
  }, [offersQuery.isLoading]);

  return (
    <StyledWrapper hasLightBg={brief}>
      {!brief && <Header />}
      <StyledMain>
        <OfferTypeConfirm
          message1={message1 || offerTypeLabels.message1}
          message2={message2 || offerTypeLabels.message2}
        />
        {offersQuery.data && <StyledAllProducts offers={offers} brief={!!brief} />}
      </StyledMain>
      {!brief && (
        <>
          <Faq faqList={faqList} />
          <Footer />
        </>
      )}
    </StyledWrapper>
  );
}

export default AppSubscribe;
